module.exports = __webpack_public_path__ + "media/aloe-large.da24ffaa.mp4";